import React from 'react';
import { Modal, Descriptions, Tag, Empty } from 'antd';

const FullResultModal = ({ open, onCancel, data, title = "Full Details" }) => {
  if (!data && open) return <Modal open={open} onCancel={onCancel} footer={null}><Empty /></Modal>;

  const renderValue = (val) => {
    if (typeof val === 'boolean') return <Tag color={val ? 'green' : 'red'}>{val ? 'TRUE' : 'FALSE'}</Tag>;
    if (val === null || val === undefined) return <span style={{ color: '#bfbfbf' }}>—</span>;
    if (Array.isArray(val)) {
        if (val.length === 0) return <span style={{ color: '#bfbfbf' }}>Empty</span>;
        if (typeof val[0] === 'object') return <pre style={{ fontSize: '10px', background: '#f5f5f5', padding: '4px' }}>{JSON.stringify(val, null, 2)}</pre>;
        return val.join(', ');
    }
    if (typeof val === 'object') return <pre style={{ fontSize: '10px', background: '#f5f5f5', padding: '4px' }}>{JSON.stringify(val, null, 2)}</pre>;
    return <span style={{ fontWeight: 500 }}>{String(val)}</span>;
  };

  const items = data ? Object.entries(data).map(([key, value]) => ({
    key,
    label: key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase()), // camelCase to Title Case
    children: renderValue(value),
  })) : [];

  return (
    <Modal
      title={<span style={{ fontSize: '18px', fontWeight: 700 }}>{title}</span>}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={900}
      style={{ top: 40 }}
      bodyStyle={{ maxHeight: '75vh', overflowY: 'auto', padding: '24px' }}
    >
      {items.length > 0 ? (
        <Descriptions 
          bordered 
          column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} 
          size="small" 
          items={items}
          labelStyle={{ background: '#fafafa', fontWeight: 600, width: '200px' }}
        />
      ) : (
        <Empty description="No record details found" />
      )}
    </Modal>
  );
};

export default FullResultModal;
